// extracted by mini-css-extract-plugin
module.exports = {"detailsContainer":"ImageDetailsModal_detailsContainer__1QO95","title":"ImageDetailsModal_title__CpBe3"};